import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';

export const LAYOUT_FEATURE_KEY = 'layout';

interface LayoutState {
  isLoading: boolean;
  refetchData: boolean;
  showSidebar: boolean;
}

const createInitialState = (): LayoutState => ({
  isLoading: false,
  refetchData: false,
  showSidebar: true,
});

const layoutSlice = createSlice({
  name: LAYOUT_FEATURE_KEY,
  initialState: createInitialState(),
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setShowSideBar(state, action: PayloadAction<boolean>) {
      state.showSidebar = action.payload;
    },
    setRefetchData(state, action: PayloadAction<boolean>) {
      state.refetchData = action.payload;
    },
  },
});

const selectLayoutState = (
  state: { [LAYOUT_FEATURE_KEY]: LayoutState },
) => state[LAYOUT_FEATURE_KEY];

export const selectIsLoading = createSelector(
  selectLayoutState,
  (state: LayoutState) => state.isLoading,
);

export const selectShowSidebar = createSelector(
  selectLayoutState,
  (state: LayoutState) => state.showSidebar,
);

export const selectRefetchData = createSelector(
  selectLayoutState,
  (state: LayoutState) => state.refetchData,
);

export const {
  setLoading,
  setShowSideBar,
  setRefetchData,
} = layoutSlice.actions;

export default layoutSlice.reducer;
